import Home from '../pages/Home';
import Services from '../pages/Services/Services';
import Plumbing from '../pages/Services/Plumbing';
// import AirConditioning from '../pages/Services/AirConditioning';
import ElectricalRepair from '../pages/Services/ElectricalRepair';
import MechanicalWorks from '../pages/Services/MechanicalWorks';
// import ExteriorRenovations from '../pages/Services/ExteriorRenovations';
// import InteriorRenovations from '../pages/Services/InteriorRenovations';
import About from '../pages/About';
import Portfolio from '../pages/Portfolio';
import Faqs from '../pages/Faqs';
import Contact from '../pages/Contact';
import Gallery from '../pages/Gallery';

export const routes = [
    { path: '/:lang/', element: Home },
    { path: '/:lang/services', element: Services },
    { path: '/:lang/services/plumbing', element: Plumbing },
    // { path: '/:lang/services/air-conditioning', element: AirConditioning },
    { path: '/:lang/services/electrical-services', element: ElectricalRepair },
    { path: '/:lang/services/mechanical-works', element: MechanicalWorks },
    // { path: '/:lang/services/exterior-renovations', element: ExteriorRenovations },
    // { path: '/:lang/services/interior-renovations', element: InteriorRenovations },
    { path: '/:lang/about', element: About },
    { path: '/:lang/portfolio', element: Portfolio },
    { path: '/:lang/faqs', element: Faqs },
    { path: '/:lang/contact', element: Contact },
    { path: '/:lang/gallery', element: Gallery },
];

export const headerRoutes = [
    {
        path: '/services', text: 'header.services', routes: [
            { path: '/services/mechanical-works', text: 'header.services.mechanical-works' },
            { path: '/services/electrical-services', text: 'header.services.electrical-services' },
            { path: '/services/plumbing', text: 'header.services.plumbing' },
            // { path: '/services/air-conditioning', text: 'header.services.air-conditioning' },
            // { path: '/services/exterior-renovations', text: 'header.services.exterior-renovations' },
            // { path: '/services/interior-renovations', text: 'header.services.interior-renovations' },
        ]
    },
    { path: '/about', text: 'header.about-us' },
    { path: '/portfolio', text: 'header.portfolio' },
    { path: '/faqs', text: 'header.faqs' },
    { path: '/contact', text: 'header.contact-us' },
    { path: '/gallery', text: 'header.gallery' },
];
